// 이 값 하나만 변경하면 전체 브랜드 팔레트가 같은 색상 계열로 자동 생성됩니다.
const mainColor = '#2348a9'

const normalizeHex = color => {
  const hex = color.replace('#', '')
  return hex.length === 3
    ? hex.split('').map(value => value + value).join('')
    : hex
}

const hexToRgb = color => {
  const hex = normalizeHex(color)
  return {
    red: parseInt(hex.slice(0, 2), 16),
    green: parseInt(hex.slice(2, 4), 16),
    blue: parseInt(hex.slice(4, 6), 16)
  }
}

const rgbToHex = ({red, green, blue}) => {
  const toHex = value => Math.round(value).toString(16).padStart(2, '0')
  return `#${toHex(red)}${toHex(green)}${toHex(blue)}`.toUpperCase()
}

const mixColor = (source, target, ratio) => {
  const sourceRgb = hexToRgb(source)
  const targetRgb = hexToRgb(target)
  const mix = key => sourceRgb[key] + (targetRgb[key] - sourceRgb[key]) * ratio

  return rgbToHex({
    red: mix('red'),
    green: mix('green'),
    blue: mix('blue')
  })
}

const tint = (color, ratio) => mixColor(color, '#FFFFFF', ratio)
const shade = (color, ratio) => mixColor(color, '#000000', ratio)

const alpha = (color, opacity) => {
  const {red, green, blue} = hexToRgb(color)
  return `rgba(${red}, ${green}, ${blue}, ${opacity})`
}

const createBrandColor = color => {
  const primary = shade(color.toUpperCase(), .06)
  const primaryStrong = shade(primary, .18)

  return {
    primary,
    primaryStrong,
    primaryHover: shade(primary, .28),
    primaryLight: tint(primary, .14),
    primarySoft: tint(primary, .86),
    primarySoftHover: tint(primary, .74),
    primarySoftest: tint(primary, .94),
    primaryBorder: tint(primary, .56),
    primaryBorderStrong: tint(primary, .38),
    primaryOpacity05: alpha(primary, .05),
    primaryOpacity08: alpha(primary, .08),
    primaryFocusRing: alpha(primary, .1),
    primaryOpacity12: alpha(primary, .12),
    primaryOpacity16: alpha(primary, .16),
    primaryShadow: alpha(primary, .18),
    primaryOpacity20: alpha(primary, .2),
    primaryOpacity45: alpha(primary, .45),
    primaryTransparent: alpha(primary, 0),
    primaryStrongOpacity06: alpha(primaryStrong, .06),
    primaryStrongOpacity08: alpha(primaryStrong, .08),
    primaryStrongShadow: alpha(primaryStrong, .1),
    primaryStrongOpacity12: alpha(primaryStrong, .12),
    primaryStrongOpacity14: alpha(primaryStrong, .14),
    primaryStrongOpacity20: alpha(primaryStrong, .2)
  }
}

const brandColor = createBrandColor(mainColor)
const subColor = brandColor.primary

const accentColor = {
  accentRed: '#DC2626',
  accentRedSoft: '#FEE2E2',
  accentRedBorder: '#FCA5A5',
  accentOrange: '#EA580C',
  accentOrangeSoft: '#FFEDD5',
  accentOrangeBorder: '#FDBA74',
  accentYellow: '#CA8A04',
  accentYellowSoft: '#FEF9C3',
  accentYellowBorder: '#FDE047',
  accentGreen: '#047857',
  accentGreenSoft: '#D1FAE5',
  accentGreenBorder: '#6EE7B7',
  accentPurple: '#6D28D9',
  accentPurpleSoft: '#EDE9FE',
  accentPurpleBorder: '#C4B5FD'
}

export const light = {
  color: {
    ...brandColor,
    ...accentColor,
    mainColor,
    mainColorOpacity20: alpha(mainColor, .2),
    mainColorOpacity5: alpha(mainColor, .05),
    subColor,
    subColorOpacity20: alpha(subColor, .2),
    subColorOpacity5: alpha(subColor, .05),
    bgColor: '#f8f8f8',
    textColor: '#222222',
    reverseTextColor: '#aaaaaa',
    topicColor: subColor,
    borderColor: '#e9ebee',
    lightGray: '#ddd',
    whiteColor: '#ffffff',
    linkColor: subColor
  }
}
